module.exports = __webpack_public_path__ + "static/media/basketball.e19aa364.png";